/**
 * @file Actions for table format release tour
 * @see https://app.commandbar.com/editor/product-tours/15533
 */

import { safeLocalStorage } from '@@/bits/safe_storage'

/**
 * @see https://app.commandbar.com/editor/actions/881443
 */
async function convertWallToTableFormat(): Promise<void> {
  const { useSurfaceSettingsStore } = await import('@@/pinia/surface_settings')
  const surfaceSettingsStore = useSurfaceSettingsStore()
  surfaceSettingsStore.startWallAttributesPreview()
  await surfaceSettingsStore.convertWallLayout('table')
  safeLocalStorage.setItem('commandbar_surfaceTableFormatNudge_triggered', 'true')
}

/**
 * @see https://app.commandbar.com/editor/actions/882528
 */
async function revertWallConversion(): Promise<void> {
  const { useSurfaceSettingsStore } = await import('@@/pinia/surface_settings')
  const surfaceSettingsStore = useSurfaceSettingsStore()
  surfaceSettingsStore.startWallAttributesPreview()
  const previousLayout = surfaceSettingsStore.previousViz ?? 'grid'
  await surfaceSettingsStore.convertWallLayout(previousLayout)
}

export { convertWallToTableFormat, revertWallConversion }
